import React from 'react'
import Subheader from '../Subheader'
import Navbar from '../Navbar'
import ArrayProperties from './ArrayProperties'

function AllProperties() {
  return (
    <div>
        <Subheader/>
        <Navbar/>
        <ArrayProperties/>
    </div>
  )
}

export default AllProperties